import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { actionsQueryOptions } from '../../../../-hooks/useActionsQuery';
import type { ActionsQuickFilter } from '../../../../-types';

interface Search {
  quickFilter?: ActionsQuickFilter | undefined;
  page?: number | undefined;
  limit?: number | undefined;
  sort?: string | undefined;
  filters?: Record<string, string[]> | undefined;
}

export const Route = createFileRoute(
  '/(client)/capa/(pages)/(list)/actions/archived/',
)({
  loaderDeps: ({ search }: { search: Search }) => ({
    quickFilter: (search.quickFilter ?? 'all') as ActionsQuickFilter,
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    sort: search.sort,
    filters: search.filters,
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      actionsQueryOptions({
        isArchiveView: true,
        quickFilter: deps.quickFilter,
        page: deps.page,
        count: deps.limit,
        ...(deps.sort !== undefined ? { sort: deps.sort } : {}),
        ...(deps.filters !== undefined ? { filters: deps.filters } : {}),
      }),
    ),
  component: lazyRouteComponent(
    () => import('../../../../-components/ActionsArchivedRoute'),
    'ActionsArchivedRoute',
  ),
});
